import { OrderBy, ResolveListOrderParams } from './useList.types';

export const resolveListOrder = ({ order, defaultOrder }: ResolveListOrderParams): OrderBy =>
  order && Object.keys(order).length > 0 ? order : (defaultOrder ?? {});
